import {connect} from 'react-redux';
import C, {RequestTypes} from '../../constants';
import Intro from "../ui/Intro";
import {recordTestResults} from "../../store/actions";

const mapStateToProps = state => {
    return {
        age: Number.parseInt(state.session.age),
        sex: state.session.sex,
        userAgree: state.session.userAgree,
        req: {
            type: RequestTypes.RECORD_USER_AGREE,
            session: {
                age: state.session.age,
                sex: state.session.sex,
                userAgree: state.session.userAgree
            }
        }
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setUserAge(age) {
            dispatch({
                type: C.SET_USER_AGE,
                payload: age
            })
        },
        setUserSex(sex) {
            dispatch({
                type: C.SET_USER_SEX,
                payload: sex
            })
        },
        setUserAgree(isAgree) {
            dispatch({
                type: C.USER_AGREE,
                payload: isAgree
            })
        },
        sendUserAgree(req) {
            dispatch(recordTestResults(req));
            dispatch({
                type: C.SET_SHOW_TEST,
                payload: true
            })
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Intro)
